module.exports = __webpack_public_path__ + "static/media/icon_config_launch.967ec39b.svg";